<template>
	<section>
		<bread-crumb></bread-crumb>
		<ul class="personal-wrap">
			<li>
				<span>头像</span>
				<img :src="userIcon" v-show="userInfo.user_icon"/>
                <img src="../../assets/img/user_icon.png" v-show="!userInfo.user_icon"/>
			</li>
            
            <li>
            	<span>昵称</span>
                <input type="text" placeholder="请输入用户昵称" ref='name' v-model='userInfo.user_name' :readonly="isNameRead"/>
                <div @click="edit('name')">修改</div>
            </li>
            
            <li>
            	<span>手机号</span>
                <input type="text" placeholder="请输入用户昵称" ref='mobile' v-model='userInfo.account' :readonly="isMobileRead"/>
                <!-- <div @click="edit('mobile')">{{mobileText}}</div> -->
                <em>仅自己可见</em>
            </li>
            
            <li>
            	<span>QQ号</span>
                <input type="text" placeholder="请输入用户QQ号" ref='qq' v-model='userInfo.qq' :readonly="isQQRead"/>
                <div @click="edit('qq')">修改</div>
                <em>仅自己可见</em>
            </li>
            
            <li>
            	<span>旺旺号</span>
                <select v-model='userInfo.wangwang'>
                    <option v-for="(item,index) in options" :key="index" :value="item.uuid">{{item.wangwang}}</option>
                </select>
            </li>
		</ul>
        
        <div class='btn-wrap'>
            <div class="save" @click="modifyUserInfo">保存</div>
            <div class="login-out" @click="loginOut">退出登录</div>
        </div>
		
	</section>
</template>

<script>
import BreadCrumb from '@/components/BreadCrumb.vue';	
import {modifyUserInfo} from '@/api/personal';
import {getUserWangWang} from '@/api/order.js';
import {mapState,mapActions} from "vuex";
import utils from '@/assets/js/utils';
export default {
    data() {
    	return {
            isNameRead:true,
            isMobileRead:true,
            isQQRead:true,
            nameText:"修改",
            mobileText:"修改",
            qqText:"修改",
            options:[]
		};
    },
    
    computed: {
    	...mapState(["userInfo","communalInfo"]),

      userIcon(){
        return this.httpFilterFUN(this.userInfo.user_icon) ? this.userInfo.user_icon : this.imgUrl + this.userInfo.user_icon
      }
    },
    
    created(){
        this.selectUsedWang();
        this.getUserInfo();
    },
  
    methods:{
        ...mapActions(["getUserInfo"]),
        //获取用常用旺旺号
        async selectUsedWang(){
        	const { data, status } = await getUserWangWang();
        	if (status !== 200) return;
        	if(data.char && data.char.length > 0){
        		this.options = data.char;
        	}
        },
        
        edit(val){
            const action = {
                name:()=>{
                    this.isNameRead = false;
                    this.$refs["name"].focus();
                },
                
                mobile:()=>{
                    this.isMobileRead = false;
                    this.$refs["mobile"].focus();
                },
                
                qq:()=>{
                    this.isQQRead = false;
                    this.$refs["qq"].focus();
                }
            }
            action[val] && action[val]();
        },
        
        async modifyUserInfo(){
            if(this.isNameRead && this.isQQRead){
                this.$message("你没有修改任何信息")
                return
            }
            const { data, status } = await modifyUserInfo(this.userInfo.uuid,this.userInfo);
            if (status == 200){
                if(data.success == "success"){
                    this.$message.success("信息修改成功");
                    this.getUserInfo();
                }
                else{
                   this.$message.error("信息修改失败");
                }
            }
        },
        
        async loginOut(){
            utils.setCookie('X-Access-Token', "", -1);
            utils.removeSession('X-Access-Token');
            utils.removeSession('imgUrl');
            this.$router.push('./login');
        },

      httpFilterFUN(valueStr) {
        if (valueStr != "" && valueStr != null) {
          if (valueStr.indexOf("www") >= 0 || valueStr.indexOf("http") >= 0 || valueStr.indexOf("https") >= 0) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      },
    },
   
	components: {
	    BreadCrumb
	},

};
</script>

<style lang="scss" scoped>
    .personal-wrap{
        margin-top: 30px;
        padding: 60px 0 60px 60px;
        background: #FFFFFF;
        box-shadow: 1px 3px 6px 0px rgba(102, 102, 102, 0.16);
        li{
            display: flex;
            align-items: center;
            margin-bottom: 60px;
            @include font-style;
            font-size: 18px;
            span{
                color: #9A9A9A;
                width: 60px;
                margin-right: 60px;
            }
            input{
                @include font-style;
                font-size: 18px;
                color: #000000;
                width: 260px;
            }
            div{
                margin-right: 40px;
                cursor: pointer;
                color: #FF8E1C;
            }
            em{
                font-style: normal;
                color: #9A9A9A;
                font-size: 14px;
            }
            img{
                width: 60px;
                height: 60px;
            }
            
            select{
                cursor: pointer;
                appearance: none;
                border: none;
                outline: none;
                width: 200px;
                height: 44px;
                line-height: 44px;
                padding-left: 30px;
                background: #F5F9FC url(../../assets/img/arrow-bottom.png) no-repeat 154px center;
                background-size: 16px 8px;
                option{
                   cursor: pointer; 
                }
            }
        }
        li:last-child{
            margin-bottom:0;
        }
    }
    .btn-wrap{
        display: flex;
        align-items: center;
        margin-top: 60px;
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        .save{
            width: 360px;
            height: 80px;
            margin-right: 40px;
            line-height: 80px;
            text-align: center;
            background: #FF8D1C;
            box-shadow: 0px 8px 10px 0px rgba(31, 56, 117, 0.08);
            border-radius: 5px;
            color: #FFFFFF;
            cursor: pointer;
        }
        .login-out{
            width: 170px;
            height: 80px;
            line-height: 80px;
            text-align: center;
            background: #FFFFFF;
            border: 1px solid #999999;
            box-shadow: 0px 8px 10px 0px rgba(31, 56, 117, 0.08);
            border-radius: 5px;
            color: #999999;
            cursor: pointer;
        }
    }
	

</style>
